import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './UserStore';  // Ensure this path is correct

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
};

// Creating a persisted reducer
const persistedReducer = persistReducer(persistConfig, authReducer);

// Configuring the store
const store = configureStore({
  reducer: {
    auth: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/FLUSH', 'persist/PAUSE', 'persist/PURGE', 'persist/REGISTER'],
      },
    }),
});

// Creating the persistor
export const persistor = persistStore(store);

// Exporting the store
export default store;
